import React from "react";
import { useEffect, useState, useContext } from "react";
import Select from "react-select";
import _ from "lodash";
import { useHistory } from "react-router-dom";

import { NotificationAlertContext } from "contexts/notificationAlertContext";
import {
  getList,
  addUser,
  fetchCurrentEula,
  getUser,
} from "graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";
import SweetAlert from "react-bootstrap-sweetalert";
import EULAModal from "../EULAComponent/EULAModal";
import { AuthContext } from "contexts/authContext";
import { tourGuideSteps } from "views/Users/CreateUpdateUserSteps";
import { useTour } from "@reactour/tour";

// react-bootstrap components
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";

const sweetAlertCustom = {
  display: "block",
  marginTop: "-100px",
  fontSize: "14px",
  overflow: "auto",
  textAlign: "left",
  width: "80%",
};

function CreateUpdateUser(props) {
  // Contexts
  const notify = useContext(NotificationAlertContext);
  const history = useHistory();
  const isUserProfile = props.location.pathname.includes("/admin/user-profile");
  const userData = props.location.state;
  const currentUser = useContext(AuthContext);
  const isInternal = currentUser.groupName === "internal";
  const userClientId = currentUser.clientId;

  const [showLoader, setShowLoader] = useState(false);
  const [userEmailAddress, setUserEmailAddress] = useState(
    isUserProfile ? null : userData?.email_id
  );
  const [userFirstName, setUserFirstName] = useState(
    isUserProfile ? null : userData?.first_name
  );
  const [userLastName, setUserLastName] = useState(
    isUserProfile ? null : userData?.last_name
  );
  const [eulaVersionId, setEulaVersionId] = useState(null);
  const [eulaContent, setEulaContent] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({
    email_id: "",
    first_name: "",
    last_name: "",
    user_group: 0,
    client_id: "",
    client_name: "",
    user_id: "",
    notify_user: "",
    is_hidden: "",
  });
  let type = {},
    isUpdate = false,
    userIdToEdit;
  if (userData?.user_group == 1) {
    type = { value: "internal", label: "Internal" };
  } else if (userData?.user_group == 2) {
    type = { value: "internal_readonly", label: "Internal Read Only" };
  } else {
    type = { value: "external", label: "External" };
  }

  if (userData?.user_id || isUserProfile) {
    isUpdate = true;
    userIdToEdit = userData?.user_id;
  }

  const [userType, setUserType] = useState(type);
  const [clientAffiliation, setClientAffiliation] = useState(
    !isInternal
      ? {
          value: currentUser.clientId,
          label: currentUser.clientName,
        }
      : null
  );
  const [clientOptions, setClientOptions] = useState([]);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const [alert, setAlert] = React.useState(null);
  const [isChecked, setIsChecked] = useState(
    userData?.notify_user ? userData?.notify_user : false
  );
  const [isDisableUserChecked, setIsDisableUserChecked] = useState(
    userData?.is_hidden ? userData?.is_hidden : false
  );
  const [isExternalAdminUserChecked, setIsExternalAdminUserChecked] =
    useState(false);

  // Tour Guide
  const { setIsOpen, setCurrentStep, setSteps } = useTour();

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const handleDisableCheckboxChange = () => {
    setIsDisableUserChecked(!isDisableUserChecked);
  };
  const hideAlert = () => {
    setAlert(null);
  };

  const createUser = async (variables) => {
    try {
      setDisableSubmit(true);
      const response = await API.graphql(graphqlOperation(addUser, variables));
      if (response.data?.addUser?.success) {
        notify("success");
        setUserEmailAddress("");
        setUserFirstName("");
        setUserLastName("");
        setTimeout(() => {
          history.goBack();
        }, 3000);
      } else if (
        response.data?.addUser?.message.includes("UsernameExistsException")
      ) {
        console.error("Email Id Already Exists");
        notify("danger", "Email Id Already Exists");
      } else if (
        response.data?.addUser?.message.includes("UserNotFoundException")
      ) {
        console.error("Email Id Does Not Exist in Cognito User Pool");
        notify("danger", "Email Id Does Not Exist in Cognito User Pool");
      } else {
        console.error(response.data?.addUser?.message);
        notify("danger");
      }
    } catch (error) {
      console.error(error);
      notify("danger");
    } finally {
      setDisableSubmit(false);
      setShowLoader(false);
    }
  };

  // Fetch options for clients
  const fetchList = async (type) => {
    try {
      const response = await API.graphql(graphqlOperation(getList, { type }));
      if (response.data?.getList?.success) {
        const options = response.data.getList
          ? response.data.getList.body
              .map((client) => {
                const option = {
                  value: client.id,
                  label: client.name,
                };
                if (client.id == userData?.client_id) {
                  setClientAffiliation(option);
                }
                return option;
              })
              .sort((a, b) => a.label.localeCompare(b.label))
          : [];
        if (type === "CLIENTS") {
          setClientOptions(options);
        }
        return true;
      } else {
        console.error(response.data?.getList?.message);
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const getCurrentEula = async () => {
    try {
      setShowLoader(true);
      const response = await API.graphql(graphqlOperation(fetchCurrentEula));
      if (response.data?.fetchCurrentEula?.success) {
        setEulaContent(response.data.fetchCurrentEula.body.content);
        setEulaVersionId(response.data.fetchCurrentEula.body.eula_version_id);
        setIsModalOpen(true);
      } else {
        console.error(response.data?.fetchCurrentEula?.message);
        notify("danger", `Could not fetch EULA content.`);
      }
    } catch (error) {
      console.error(error);
      notify("danger", `Could not fetch EULA content.`);
    } finally {
      setShowLoader(false);
    }
  };

  const getUserDetails = async (user_id) => {
    try {
      const response = await API.graphql(
        graphqlOperation(getUser, { user_id })
      );
      if (response.data?.getUser?.success) {
        const userDetails = response.data.getUser.body;
        if (!user_id) {
          setUserDetails({ ...userDetails });
          setUserEmailAddress(userDetails.email_id);
          setUserFirstName(userDetails.first_name);
          setUserLastName(userDetails.last_name);
          setIsChecked(userDetails.notify_user);
          setClientAffiliation({
            value: userDetails.client_id,
            label: userDetails.client_name,
          });
          if (userDetails.user_group == 1) {
            setUserType({ value: "internal", label: "Internal" });
          } else if (userDetails.user_group == 2) {
            setUserType({
              value: "internal_readonly",
              label: "Internal Read Only",
            });
          } else {
            setUserType({ value: "external", label: "External" });
          }
        }
        setIsExternalAdminUserChecked(
          userDetails.permissions?.includes("external_user_admin")
        );
        return true;
      } else {
        console.error(response.data?.getUser?.message);
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  useEffect(() => {
    async function fetchData() {
      setShowLoader(true);
      const promiseList = [];
      if (isUserProfile) {
        promiseList.push(getUserDetails());
        if (!isInternal) {
          setIsExternalAdminUserChecked(
            currentUser.permissions.includes("external_user_admin")
          );
        }
      } else if (userData?.user_id) {
        promiseList.push(getUserDetails(userData?.user_id));
      }
      if (isInternal) promiseList.push(fetchList("CLIENTS"));
      const promiseAllResults = await Promise.all(promiseList);
      const isSuccess = promiseAllResults.every((value) => value);
      if (!isSuccess) {
        notify("danger");
        history.goBack();
      }
      setShowLoader(false);
    }
    fetchData();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isUserProfile) {
      if (userDetails.email_id !== userEmailAddress) {
        notify("danger", "You can't change the email address");
        return;
      } else if (userDetails.first_name !== userFirstName) {
        notify("danger", "You can't change the first name");
        return;
      } else if (userDetails.last_name !== userLastName) {
        notify("danger", "You can't change the last name");
        return;
      }
    }
    setAlert(
      <SweetAlert
        warning
        showCancel
        style={sweetAlertCustom}
        title={
          userData || isUserProfile
            ? "Confirm to update the user details"
            : "Confirm to Add the user"
        }
        confirmBtnBsStyle="primary"
        confirmBtnText="Confirm"
        onCancel={() => hideAlert()}
        onConfirm={() => confirmUserAdd(event)}
        focusCancelBtn
      ></SweetAlert>
    );
  };
  const confirmUserAdd = (event) => {
    event.preventDefault();
    hideAlert();
    if (!userEmailAddress) notify("danger", "Please Enter User Email Address");
    else if (!userFirstName) notify("danger", "Please Enter User First Name");
    else if (!userLastName) notify("danger", "Please Enter User Last Name");
    else if (!userType) notify("danger", "Please Select User Type");
    else if (userType.value === "external" && !clientAffiliation?.value)
      notify("danger", "Please Select Client Affiliation");
    else {
      let clientAffiliationArray = [];
      if (userType.value === "external" && clientAffiliation?.value) {
        clientAffiliationArray = [
          { Name: "custom:clientId", Value: clientAffiliation?.value },
        ];
      }
      const variables = {
        email_id: userEmailAddress,
        first_name: userFirstName,
        last_name: userLastName,
        group: userType.value,
        is_notify: isChecked,
        is_hidden: isDisableUserChecked,
        custom_attributes: JSON.stringify(clientAffiliationArray),
        is_update: isUpdate,
        user_id_to_edit: userIdToEdit,
        permissions: isExternalAdminUserChecked ? ["external_user_admin"] : [],
        requester_client_id: userClientId,
      };
      createUser(variables);
      notify("info");
    }
  };

  if (showLoader) return <Spinner animation="grow" />;

  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col>
            <h2>
              {isUserProfile
                ? "User Profile"
                : userData
                ? "Edit User"
                : "Add User"}
            </h2>
          </Col>
          {currentUser.groupName === "external" && (
            <Col className="my-auto text-right">
              <Button
                variant="secondary"
                className="btn-outline"
                onClick={() => {
                  setSteps(tourGuideSteps);
                  setCurrentStep(0);
                  setIsOpen(true);
                }}
              >
                <i className="fas fa-desktop"></i> View Our Tour Guide
              </Button>
            </Col>
          )}
        </Row>
        <Row>
          <Col md="12">
            <Card>
              <Card.Body>
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <label>User's Email Address</label>
                        <Form.Control
                          id="email"
                          placeholder="User's Email Address"
                          type="email"
                          disabled={isUserProfile || userData}
                          required
                          value={userEmailAddress}
                          onChange={(e) => setUserEmailAddress(e.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <label>User's First Name</label>
                        <Form.Control
                          id="firstname"
                          placeholder="User's First Name"
                          type="text"
                          disabled={isUserProfile}
                          required
                          value={userFirstName}
                          onChange={(e) => setUserFirstName(e.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <label>User's Last Name</label>
                        <Form.Control
                          id="lastname"
                          placeholder="User's Last Name"
                          type="text"
                          disabled={isUserProfile}
                          required
                          value={userLastName}
                          onChange={(e) => setUserLastName(e.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>User Type</label>
                        <Select
                          id="type"
                          className="react-select primary"
                          classNamePrefix="react-select"
                          name="userType"
                          isDisabled={isUserProfile || !isInternal}
                          value={userType}
                          required
                          onChange={(value) => setUserType(value)}
                          options={[
                            { value: "internal", label: "Internal" },
                            {
                              value: "internal_readonly",
                              label: "Internal Read Only",
                            },
                            { value: "external", label: "External" },
                          ]}
                          placeholder="Select User Type"
                        />
                      </Form.Group>
                    </Col>
                    {userType && userType.value == "external" && (
                      <Col md="6">
                        <Form.Group>
                          <label>Client Affiliation</label>
                          <Select
                            id="affiliation"
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="clientAffiliation"
                            isDisabled={isUserProfile || !isInternal}
                            value={clientAffiliation}
                            required
                            onChange={(value) => setClientAffiliation(value)}
                            options={clientOptions}
                            placeholder="Select Client Affiliation"
                          />
                        </Form.Group>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col md="12" id="enable-notification-button">
                      <Form.Group>
                        <Form.Check>
                          <Form.Check.Label>
                            <Form.Check.Input
                              type="checkbox"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                            ></Form.Check.Input>
                            <span className="form-check-sign"></span>
                            Enable User Notifications
                          </Form.Check.Label>
                        </Form.Check>
                      </Form.Group>
                    </Col>
                  </Row>
                  {!isUserProfile && (
                    <>
                      {userData && (
                        <Row>
                          <Col md="12">
                            <Form.Group>
                              <Form.Check>
                                <Form.Check.Label>
                                  <Form.Check.Input
                                    type="checkbox"
                                    checked={isDisableUserChecked}
                                    onChange={handleDisableCheckboxChange}
                                  ></Form.Check.Input>
                                  <span className="form-check-sign"></span>
                                  Disable User
                                </Form.Check.Label>
                              </Form.Check>
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                  {userType && userType.value == "external" && (
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Check>
                            <Form.Check.Label>
                              <Form.Check.Input
                                type="checkbox"
                                checked={isExternalAdminUserChecked}
                                disabled={isUserProfile}
                                onChange={() =>
                                  setIsExternalAdminUserChecked(
                                    !isExternalAdminUserChecked
                                  )
                                }
                              ></Form.Check.Input>
                              <span className="form-check-sign"></span>
                              <span className={isUserProfile ? "form-check-label disabled" : "form-check-label"}>
                                Make User External Admin
                              </span>
                            </Form.Check.Label>
                          </Form.Check>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <Button
                        className="btn-fill"
                        id="update-create-user-button"
                        type="submit"
                        variant="primary"
                        disabled={disableSubmit}
                      >
                        {userData || isUserProfile ? "Update" : "Create"} User
                      </Button>
                      {isUserProfile && (
                        <Button
                          id="show-eula-button"
                          className="btn-outline ml-4"
                          variant="primary"
                          onClick={getCurrentEula}
                        >
                          Show EULA
                        </Button>
                      )}
                    </Col>
                  </Row>
                </form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {isUserProfile && (
          <EULAModal
            isOpen={isModalOpen}
            readOnly={true}
            onClose={() => setIsModalOpen(false)}
            eulaContent={eulaContent}
          />
        )}
      </Container>
    </>
  );
}

export default CreateUpdateUser;
